import { Action } from '@ngrx/store';
import { IInvoiceInfo } from '@cakeiteasy/web-utils';
import { IUser } from '../models/i-user';

const prefix = '[USER] ';

export const LOAD_USER = prefix + 'Load User';
export const LOAD_USER_FAIL = prefix + 'Load User Fail';
export const LOG_USER_OUT = prefix + 'Log User Out';
export const LOAD_USER_SUCCESS = prefix + 'Load User Success';
export const UPDATE_USER_INFO = prefix + 'Update User Info';
export const UPDATE_USER_INVOICE_INFO = prefix + 'Update User InvoiceInfo';

export class LoadUser implements Action {
  readonly type = LOAD_USER;
}

export class LoadUserFail implements Action {
  readonly type = LOAD_USER_FAIL;

  constructor(public payload: any) {
  }
}

export class LogUserOut implements Action {
  readonly type = LOG_USER_OUT;

  constructor() {}
}

export class LoadUserSuccess implements Action {
  readonly type = LOAD_USER_SUCCESS;

  constructor(public payload: IUser) {
  }
}

export class UpdateUserInfo implements Action {
  readonly type = UPDATE_USER_INFO;

  constructor(public payload: IUser) {
  }
}

export class UpdateUserInvoiceInfo implements Action {
  readonly type = UPDATE_USER_INVOICE_INFO;

  constructor(public payload: IInvoiceInfo) {
  }
}

// action types
export type UserAction =
  | LoadUser
  | LoadUserFail
  | LoadUserSuccess
  | UpdateUserInfo
  | LogUserOut
  | UpdateUserInvoiceInfo;

